import React, { useState, useEffect } from 'react';
import { getUserProfile } from '../services/firestoreService';
import './AffiliatePage.css';

const COMMISSIONS = [
  { plan: 'Pro',   price: '₹999/mo',  commission: '₹300/mo' },
  { plan: 'Elite', price: '₹1999/mo', commission: '₹600/mo' },
];

const AffiliatePage = ({ currentUser }) => {
  const [profile, setProfile] = useState(null);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser?.id) return;
    getUserProfile(currentUser.id).then((p) => {
      setProfile(p);
      setLoading(false);
    });
  }, [currentUser]);

  // Generate referral code for existing users who don't have one
  const referralCode = profile?.referralCode || ('TF' + (currentUser?.id || '').slice(0, 6).toUpperCase());
  const referralLink = `https://tradefixai.in/signup?ref=${referralCode}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const totalReferrals = profile?.totalReferrals || 0;
  const totalEarned = profile?.affiliateEarnings || 0;
  const pendingPayout = profile?.pendingPayout || 0;

  if (loading) {
    return (
      <div className="affiliate-page" style={{ textAlign: 'center', paddingTop: 60 }}>
        <p style={{ color: 'var(--text-muted)' }}>Loading affiliate data…</p>
      </div>
    );
  }

  return (
    <div className="affiliate-page">
      <div className="affiliate-header">
        <h1>Affiliate Program</h1>
        <p>Earn recurring commissions by referring traders to TradeFix AI.</p>
      </div>

      {/* Payout ready banner */}
      {pendingPayout >= 500 && (
        <div className="payout-banner">
          <div className="payout-banner-text">
            You have <span>₹{pendingPayout}</span> ready for payout!
          </div>
          <button className="payout-request-btn" onClick={() => alert('Payout request sent! We will process it within 3-5 business days.')}>
            Request Payout
          </button>
        </div>
      )}

      {/* Referral link */}
      <div className="referral-card">
        <h3>Your Referral Link</h3>
        <div className="referral-link-row">
          <input
            className="referral-link-input"
            type="text"
            value={referralLink}
            readOnly
          />
          <button className={`copy-btn ${copied ? 'copied' : ''}`} onClick={handleCopy}>
            {copied ? 'Copied!' : 'Copy Link'}
          </button>
        </div>
        <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 10 }}>
          Your referral code: <strong style={{ color: 'var(--accent)' }}>{referralCode}</strong>
        </p>
      </div>

      {/* Stats */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-label">Total Referrals</div>
          <div className="stat-value">{totalReferrals}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Total Earned</div>
          <div className="stat-value accent">₹{totalEarned.toLocaleString('en-IN')}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Pending Payout</div>
          <div className="stat-value accent">₹{pendingPayout.toLocaleString('en-IN')}</div>
        </div>
      </div>

      {/* How it works */}
      <div className="section-title">How It Works</div>
      <div className="steps-grid">
        <div className="step-card">
          <div className="step-num">1</div>
          <div className="step-title">Share your link</div>
          <div className="step-desc">Share your unique referral link with traders in your network.</div>
        </div>
        <div className="step-card">
          <div className="step-num">2</div>
          <div className="step-title">They subscribe</div>
          <div className="step-desc">When they sign up and purchase any paid plan, you earn a commission.</div>
        </div>
        <div className="step-card">
          <div className="step-num">3</div>
          <div className="step-title">You earn monthly</div>
          <div className="step-desc">Earn recurring commissions every month they stay subscribed.</div>
        </div>
      </div>

      {/* Commission table */}
      <div className="section-title">Commission Structure</div>
      <table className="commission-table">
        <thead>
          <tr>
            <th>Plan</th>
            <th>Plan Price</th>
            <th>Your Commission</th>
          </tr>
        </thead>
        <tbody>
          {COMMISSIONS.map((row) => (
            <tr key={row.plan}>
              <td>{row.plan}</td>
              <td>{row.price}</td>
              <td className="commission-amount">{row.commission}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>
        Payouts are processed once your pending balance reaches ₹500. Commissions are paid within 3–5 business days of the payout request.
      </p>
    </div>
  );
};

export default AffiliatePage;
